import * as React from "react";

type CloseListOnItemDetailsUnmountProps = {
  children: React.ReactNode;
  onListOpenChange?: (open: boolean) => void;
};

let itemDetailsOpenGeneration = 0;

/**
 * Closes the parent list when the item-details dialog body unmounts.
 * A generation counter ignores React Strict Mode's immediate remount.
 */
const CloseListOnItemDetailsUnmount = ({
  children,
  onListOpenChange,
}: CloseListOnItemDetailsUnmountProps) => {
  React.useEffect(() => {
    itemDetailsOpenGeneration += 1;
    const generation = itemDetailsOpenGeneration;
    return () => {
      globalThis.setTimeout(() => {
        if (itemDetailsOpenGeneration === generation) {
          onListOpenChange?.(false);
        }
      }, 0);
    };
  }, [onListOpenChange]);

  return children;
};

export { CloseListOnItemDetailsUnmount };
